import React from 'react';
import { Badge, Box } from '@mui/material';
import { MenuItemLink, useRedirect } from 'react-admin';
import { usePendingApplicationCount } from '../../hooks/usePendingApplications';
import { APPLICATION_LIST_PATHS } from '../../services/pendingApplicationsService';

/**
 * Sidebar menu link with optional pending-application badge (Upcoming Events style).
 * - Row / label click → normal list
 * - Red badge click → Applications tab (pending only)
 */
const ApplicationPendingMenuLink = ({
  companyType,
  to,
  pendingTo,
  primaryText,
  icon: Icon,
}) => {
  const redirect = useRedirect();
  const count = usePendingApplicationCount(companyType);
  const applicationsPath = pendingTo || APPLICATION_LIST_PATHS[companyType];

  const leftIcon =
    count > 0 ? (
      <Box
        component="span"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          redirect(applicationsPath);
        }}
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        title="Bekleyen başvurular"
        sx={{ display: 'inline-flex', cursor: 'pointer' }}
      >
        <Badge badgeContent={count} color="error" max={99}>
          <Icon />
        </Badge>
      </Box>
    ) : (
      <Icon />
    );

  return (
    <MenuItemLink
      to={to}
      primaryText={primaryText}
      leftIcon={leftIcon}
      style={{ fontSize: 12.5 }}
    />
  );
};

export default ApplicationPendingMenuLink;
